export default __webpack_public_path__ + "static/media/flag-fr.36bc7b01.svg";